__turbopack_context__.v({
  "canvasContainer": "HeroSection-module__eqT-TG__canvasContainer",
  "ctaContainer": "HeroSection-module__eqT-TG__ctaContainer",
  "downloadBtn": "HeroSection-module__eqT-TG__downloadBtn",
  "mainContent": "HeroSection-module__eqT-TG__mainContent",
  "primary": "HeroSection-module__eqT-TG__primary",
  "root": "HeroSection-module__eqT-TG__root",
  "subtitle": "HeroSection-module__eqT-TG__subtitle",
});
